//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AWalletHelpers from "@/assets/js/AWalletHelpers";
import AQInput from "../AQInput/AQInput.vue";

export default {
    name: "AWalletBaseCredentials",
    components: {
        AQInput,
        AQDropdown
    },
    props: {
        value: {
            type: Object
        },
        withNetwork: {
            type: Boolean,
            default: false
        },
        withPassword: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            credentials: this.value,
            errors: {
                password: {
                    active: false,
                    text: this.$t("wallet.error.passwordsNotMatching")
                },
                passwordRequirements: {
                    active: false,
                    text: this.$t("wallet.error.passwordRequirements")
                }
            },
            networkOptions: [{ label: "Ethereum", value: "Ethereum" }],
            defaultValue: ""
        };
    },
    computed: {
        passwordFieldErrorText() {
            const { password, passwordRequirements } = this.errors;
            return (password.active && password.text) || (passwordRequirements.active && passwordRequirements.text) || null;
        }
    },
    watch: {
        value(newValue) {
            this.credentials = newValue;
        }
    },
    created() {
        this.defaultValue = this.credentials.network || " ";
        this.setWalletName();
    },
    methods: {
        hasErrors() {
            if (!this.withPassword) {
                return false;
            }

            let hasErrors = false;
            const passwordReqRegex = "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"; // min 8 char, 1 upper, 1 lower, 1 num
            const {
                password,
                confirmPassword
            } = this.credentials;

            if (password !== confirmPassword) {
                this.errors.password.active = true;
                hasErrors = true;
            }

            if (!new RegExp(passwordReqRegex).test(password)) {
                this.errors.passwordRequirements.active = true;
                hasErrors = true;
            }

            return hasErrors;
        },
        onPasswordChange() {
            this.errors.password.active = false;
            this.errors.passwordRequirements.active = false;
        },
        setWalletName() {
            AWalletHelpers.getAllWallets().then(data => {
                let lastNum = 0;
                const walletPrefix = "Wallet ";
                data.forEach(e => {
                    if (e.name.startsWith(walletPrefix)) {
                        const words = e.name.split(" ");
                        if (words.length === 2) {
                            try {
                                const num = parseInt(words[1], 10);
                                if (lastNum < num) {
                                    lastNum = num;
                                }
                            } catch (err) {
                                // skip
                            }
                        }
                    }
                });
                this.credentials.name = `${walletPrefix}${lastNum + 1}`;
            });
        }
    }
};
